import {differenceInCalendarDays, differenceInCalendarMonths} from 'date-fns'

import styles from './RequestPeriod.module.scss'
import {Text, Box} from 'common/components'
import {formatDate, maybePluralize} from 'common/helpers'

interface RequestPeriodProps {
  estimated?: boolean
  from: Date
  to: Date
}

interface PointProps {
  label: string
  secondColor: boolean
  value: string
  right?: boolean
}

const Point = ({label, value, right = false}: PointProps) => (
  <Box align={right ? 'right' : undefined}>
    <Text noWrap size="xs" color="grey" mb={2}>
      {label}
    </Text>
    <Text noWrap size="xl" weight="demiBold">
      {value}
    </Text>
  </Box>
)

export default function RequestPeriod({
  estimated,
  from,
  to,
}: RequestPeriodProps) {
  const months = differenceInCalendarMonths(to, from) || 1
  const days = differenceInCalendarDays(to, from)
  const monthsArray = new Array(months).fill(null)

  return (
    <Box pb={4}>
      <div className={styles.block}>
        <Point
          label={estimated ? 'Estimated open' : 'Open'}
          secondColor={!estimated}
          value={formatDate(from, 'fifth')}
        />
        <p className={styles.duration}>{maybePluralize(days, 'day')}</p>
        <Point
          right
          label={estimated ? 'Estimated maturity' : 'Maturity'}
          secondColor={!estimated}
          value={formatDate(to, 'fifth')}
        />
      </div>
      <div className={styles.line}>
        {monthsArray.map((_, index) => (
          <div key={index} className={styles.dash} />
        ))}
      </div>
    </Box>
  )
}
